// https://patorjk.com/software/taag/#p=display&f=Colossal&t=Math

import {
  EKitInstancePOSTResp,
  SyncWrapper,
  ESkinnyKitGET,
  EUserOrgKitRecentGET,
  Body_create_lego_v1__org_id__command_templates_post,
  ESkinnyKitOutColGET,
  ESkinnyKitOutColGET_CT_OutputColumn,
  ESkinnyKitInColGET,
  ERowDecorationPOSTReq,
  ERowDecorationPOSTResp,
  ERowDecorationGET,
  ERowDecorationGET_RowDecorationColMap,
  ELegoInstanceInputPOSTReq,
  ELegoInstanceInputPATCHReq,
  ELegoInstanceInputPOSTReq_LegoInput,
  ERowDecorationPATCHReq,
  EOutputColumnGET,
  EDropdownPATCHReq,
  ELegoInstanceInputGET,
  EDropdownGET,
  EDropdownPOSTReq,
  EDropdownPOSTResp,
  ECmdTemplatePATCHReq,
  EKitInstancePOSTReq,
  EDeepKit6GET_RowDecoration,
  EDeepKit6GET_CT_OutputColumn,
  ESkinnyKitInColGET_LegoInstanceInput,
  EDeepKit6GET_CT_C_CredsAPI,
  EDeepKit6GET_CT_StaticCommandSource,
  ELegoInstanceInputPOSTResp,
  EDeepKit6GET_ObjectDecoration,
  EDeepKit6GET_OD_ObjectDecorationFieldMap,
  EObjectDecorationPOSTReq,
  EObjectDecorationPOSTResp,
  EObjectDecorationGET,
  EObjectDecorationPATCHReq,
  EOutputFieldGET,
  EBulkLegoInstanceInputPATCHReq,
  EDeepKit6GET_ED_CmdInstance,
  EErrorDecorationPOSTReq,
  EErrorDecorationPOSTResp,
  EErrorDecorationGET,
  EErrorDecorationDELETEResp,
  EKitPATCHReq,
  EInternalCredsAPIPATCHReq,
  CredsAPIPATCHResp,
  EDeepKit6GET,
  EDeepKit6GET_LegoInstanceInput,
  EDeepKit6GET_CT_CmdTemplateDb,
  ECmdTemplateDbPATCHReq,
  ECmdTemplateDbGET,
} from "../types/api-schema";
import {
  KitRunSchemaElement,
  ApiRequest,
  HttpMethod,
  InstanceSchemaElement,
  KitVisibility,
  ExecutionEnv,
  initDropdownDoll,
  DropdownDoll,
  ParamSource,
  TypeSystem,
} from "../types/general-flank-types";
import {
  pathRest,
  lfind,
  lfindIndex,
  ocopy,
  lcopy,
  lInsertAt,
  lremoveAt,
  lenumerate,
  omerge,
  ovaluemap,
  lgroupBy,
  oitems,
  lot2o,
  oget,
  pathsJoin,
  pathSplit,
  lsort,
  lfirst,
  pyfalsey,
  odiffOldNew,
  pathJoin,
  pyCoalesce,
  pytruthy,
  lunique,
  okeyfilter,
  isArray,
  enforceType,
  ldiffOrderInsensitive,
  lzipBy,
  lsplit,
  lreplace,
  lcontains,
  lmap2oGen,
  okeysGen,
  equals,
  pathFirst,
  ovalues,
  sToNumber,
} from "../brains/flang";
import {
  bindFlatParamsToSchema,
  setSchemaValuesToDefaults,
  trimDownSchema,
  strToRunrams,
  runramsToStr,
  initSchema,
  schemaToQueryString,
  schemaToExcelPreppedString,
  legoInstanceInputsToInstanceSchema,
  setSchemaValuesToVariables,
  instanceElementToLegoInputRow,
  elementEmptyValue,
  instanceElementToLegoInstanceInputRow,
  legoInstanceInputToInstanceSchemaElement,
  initElement,
} from "./params";
import { getTypeObject } from "./notOurService";

/*

8888888b.           888                  88888888888                                  
888  "Y88b          888                      888                                      
888    888          888                      888                                      
888    888  8888b.  888888  8888b.           888  888  888 88888b.   .d88b.  .d8888b  
888    888     "88b 888        "88b          888  888  888 888 "88b d8P  Y8b 88K      
888    888 .d888888 888    .d888888          888  888  888 888  888 88888888 "Y8888b. 
888  .d88P 888  888 Y88b.  888  888          888  Y88b 888 888 d88P Y8b.          X88 
8888888P"  "Y888888  "Y888 "Y888888          888   "Y88888 88888P"   "Y8888   88888P' 
                                                       888 888                        
                                                  Y8b d88P 888                        
                                                   "Y88P"  888                        

*/

export type SkinnyKitDollGroup = {
  groupName: string;
  members: string[];
  accessLevel: "org" | "dir" | "kit" | "creator";
};
export type SkinnyKitDollMember = {
  name: string;
  accessLevel: "org" | "dir" | "kit" | "creator";
};
export type SkinnyKitDoll = {
  name: string;
  kitId: number;
  orgId: string;
  isCmd: boolean;
  directoryId: number | null;
  directoryName: string | null;
  cloudName: string | null;
  visibility: KitVisibility;
  ogKitId: number | null;
  description: string | null;
  hasAccess: boolean;
  engineerGroups: SkinnyKitDollGroup[];
  runnerGroups: SkinnyKitDollGroup[];
  engineers: SkinnyKitDollMember[];
  runners: SkinnyKitDollMember[];
  nonOrgAdminEngineers: boolean;
};
export type NOOutputColDoll = {
  path: string;
  noocId: number;
  pythonTypeStr: string | null;
  pyodbcInferredType: string | null;
};
export type SkinnyKitDollOC = {
  name: string;
  kitId: number;
  orgId: string;
  directoryId: number | null;
  directoryName: string | null;
  cloudName: string | null;
  outputColumns: NOOutputColDoll[];
};
export type SkinnyKitDollIC = {
  name: string;
  kitId: number;
  orgId: string;
  directoryId: number | null;
  directoryName: string | null;
  cloudName: string | null;
  legoInstanceInputs: ESkinnyKitInColGET_LegoInstanceInput[];
};
export type RecentKitDoll = {
  name: string;
  kitId: number;
  isCmd: boolean;
  source: string;
  uokId: string;
  lastViewed: string;
};

export type CredsApiProcessed = {
  credsId: number;
  authType: string | null;
  customHeaders: Record<string, string> | null;
  bearerToken: string | null;
  username: string | null;
  password: string | null;
  usernameSource: "static" | "expose_at_runtime" | null;
  passwordSource: "static" | "expose_at_runtime" | null;
};
export type StaticCommandSourceProcessed = {
  staticCommandSourceId: number;
  filename: string | null;
};
export type RowDecorationProcessed = {
  decorationId: number;
  name: string;
  outputKitId: number;
  resultSetZeroIdx: number | null;
  inputKitId: number | null;
  creatorUoId: string;
  colMaps: ERowDecorationGET_RowDecorationColMap[];
  inputKitName: string | null;
};
export type ObjectDecorationProcessed = {
  objectDecorationId: number;
  name: string;
  outputKitId: number;
  inputKitId: number | null;
  creatorUoId: string;
  fieldMaps: EDeepKit6GET_OD_ObjectDecorationFieldMap[];
  inputKitName: string | null;
};
export type ErrorDecorationProcessed = {
  inputKitId: number;
  inputKitName: string | null;
  inputKitOrgId: string;
};

export type LegoDoll = {
  legoName: string; // coalesce(org_lego.override_name, lego.name)
  olId: string;
  syncDescription: string | null;
  directoryId: number | null;
  runOnStartup: boolean;
  runOnStartupValues: Record<string, any>;
  runCredsId: number | null;
  syncCredsId: number | null;
  cloudId: string | null;
  cloudName: string | null;
  kitRunSchema: KitRunSchemaElement[];
  warningTag: string | null;
  runButtonText: string | null;
  runningMessage: string | null;
  legoInstanceId: number;
  /*
    "schema" (group of params) consists of "elements" (individual params)
    schema: [element, element, {objectPropertySchemas: [element, element, element]}]

    legoSchemaElement (aka lego.paramSchema)       // what we sync, stuff we can determine
    instanceSchemaElement                          // settings that the user applies on top (e.g. isHidden, defaultValue)
    kitRunSchemaElement                            // "live" values that we throw away (the actual parameter value, whether it's valid, etc)
  */
  order: number | null;
  collapsedView: boolean;
  isHidden: boolean;
  // Angus: we need to populate this
  kiliId: string | null;
  executable: string | null;
  executionEnv: string;
  rowDecorations: RowDecorationProcessed[];
  objectDecorations: ObjectDecorationProcessed[];
  errorDecoration: ErrorDecorationProcessed | null;
  outputCols: EDeepKit6GET_CT_OutputColumn[] | EOutputColumnGET[];
  outputFields: EOutputFieldGET[];
  headers: Record<string, string> | null;
  credsApi: CredsApiProcessed | null;
  staticCommandSource: StaticCommandSourceProcessed | null;
  paramSource: ParamSource | null;
  typeSystem: TypeSystem | null;
};

export type LegoDollUpdate = Partial<LegoDoll>;

export type CmdProcessed = {
  kitId: number;
  orgId: string;
  legoDoll: LegoDoll;
  visibility: KitVisibility;
  name: string;
  description: string | null;
  directoryId: number | null;
  isCopycatKit: boolean | null;
  dropdowns: Record<string, DropdownDoll>;
  dbExecuteInTransaction: boolean;
  outputObjectPath: string | null;
  dbInfo: null | EDeepKit6GET_CT_CmdTemplateDb;
};

export type KitDollPlanOptions = {
  replaceParamQueryString?: boolean;
  setElementsToPropElements?: boolean;
  greenToastOnSuccess?: string;
  redToastOnFailure?: string;
};
export class KitDollPlan {
  kitDoll: CmdProcessed | null;
  parallelRequests: ApiRequest[] | null;
  kitDollRequest: ApiRequest | null;
  options: KitDollPlanOptions;
  constructor({
    kitDoll = null,
    parallelRequests = null,
    kitDollRequest = null,
    options = {},
  }: {
    kitDoll?: CmdProcessed | null;
    parallelRequests?: ApiRequest[] | null;
    kitDollRequest?: ApiRequest | null;
    options?: KitDollPlanOptions;
  } = {}) {
    this.kitDoll = kitDoll;
    this.parallelRequests = parallelRequests;
    this.options = options;
    this.kitDollRequest = kitDollRequest;
  }
  addOptions(o: KitDollPlanOptions) {
    this.options = omerge(this.options, o);
    return this;
  }
}

/*

8888888          d8b 888    d8b          888 d8b                   
  888            Y8P 888    Y8P          888 Y8P                   
  888                888                 888                       
  888   88888b.  888 888888 888  8888b.  888 888 88888888  .d88b.  
  888   888 "88b 888 888    888     "88b 888 888    d88P  d8P  Y8b 
  888   888  888 888 888    888 .d888888 888 888   d88P   88888888 
  888   888  888 888 Y88b.  888 888  888 888 888  d88P    Y8b.     
8888888 888  888 888  "Y888 888 "Y888888 888 888 88888888  "Y8888  
                                                                   
                                                                   
                                                                   

*/

function _initParamSchema6(
  legoInstanceInputs: EDeepKit6GET_LegoInstanceInput[]
) {
  const legoInstanceInputSchema = legoInstanceInputsToInstanceSchema(
    legoInstanceInputs
  );
  return initSchema(legoInstanceInputSchema, {
    from: "instance",
    to: "kitrun",
  });
}
function _initRowDecorationProcessed(
  decoration: ERowDecorationGET | EDeepKit6GET_RowDecoration
): RowDecorationProcessed {
  return {
    decorationId: decoration.decorationId,
    name: decoration.name,
    outputKitId: decoration.outputKitId,
    resultSetZeroIdx: decoration.resultSetZeroIdx,
    inputKitId: decoration.inputKitId,
    creatorUoId: decoration.creatorUoId,
    colMaps: decoration.colMaps,
    inputKitName: decoration.inputKit?.name ?? null,
  };
}
function _initObjectDecorationDoll(
  objectDecoration: EDeepKit6GET_ObjectDecoration
): ObjectDecorationProcessed {
  return {
    objectDecorationId: objectDecoration.objectDecorationId,
    name: objectDecoration.name,
    outputKitId: objectDecoration.outputKitId,
    inputKitId: objectDecoration.inputKitId,
    creatorUoId: objectDecoration.creatorUoId,
    fieldMaps: objectDecoration.fieldMaps,
    inputKitName: objectDecoration.inputKit?.name ?? null,
  };
}
function _initErrorDecorationProcessed(
  errorDecorationInputKit: EDeepKit6GET_ED_CmdInstance | null
): ErrorDecorationProcessed | null {
  if (!errorDecorationInputKit) {
    return null;
  }
  return {
    inputKitId: errorDecorationInputKit.kitId,
    inputKitName: errorDecorationInputKit.name ?? null,
    inputKitOrgId: errorDecorationInputKit.orgId,
  };
}

function _initRowDecorationProcessedList(
  rowDecorations: ERowDecorationGET[]
): RowDecorationProcessed[] {
  return rowDecorations.map(_initRowDecorationProcessed);
}
function _initObjectDecorationDollList(
  objectDecorations: EDeepKit6GET_ObjectDecoration[]
): ObjectDecorationProcessed[] {
  return objectDecorations.map(_initObjectDecorationDoll);
}
function _initCredsApiProcessed(
  credsApi: EDeepKit6GET_CT_C_CredsAPI | null
): CredsApiProcessed | null {
  if (!credsApi) {
    return null;
  }
  return {
    credsId: credsApi.credsId,
    authType: credsApi.authType,
    customHeaders: credsApi.customHeaders
      ? JSON.parse(credsApi.customHeaders)
      : null,
    bearerToken: credsApi.bearerToken,
    username: credsApi.username,
    password: credsApi.password,
    usernameSource: credsApi.usernameSource,
    passwordSource: credsApi.passwordSource,
  };
}
function _initStaticCommandSourceProcessed(
  staticCommandSource: EDeepKit6GET_CT_StaticCommandSource | null
): StaticCommandSourceProcessed | null {
  if (!staticCommandSource) {
    return null;
  }
  return {
    staticCommandSourceId: staticCommandSource.staticCommandSourceId,
    filename: staticCommandSource.filename,
  };
}
function _initLegoDoll6(deepKit: EDeepKit6GET): LegoDoll {
  if (!deepKit.anchorOl) {
    throw new Error("deepKit.anchorOl is null");
  }
  const legoInstanceInputs = deepKit.legoInstanceInputs;
  const kitRunSchema = _initParamSchema6(
    legoInstanceInputs
  ) as KitRunSchemaElement[];

  return {
    olId: deepKit.anchorOl.olId ?? "",
    order: 0,
    legoInstanceId: -1,
    kitRunSchema: kitRunSchema,
    legoName: pyCoalesce(deepKit.anchorOl.overrideName, deepKit.anchorOl.name),
    syncDescription: deepKit.anchorOl.syncDescription,
    //@ts-ignore
    directoryId: deepKit.directoryId,
    runOnStartup: deepKit.anchorOl.runOnStartup,
    runOnStartupValues: strToRunrams(deepKit.anchorOl.runOnStartupValues),
    runCredsId: deepKit.anchorOl.runCredsId,
    syncCredsId: deepKit.anchorOl.syncCredsId,
    cloudId: deepKit.anchorOl.cloudId,
    cloudName: deepKit.anchorOl.name,
    warningTag: deepKit.anchorOl.warningTag,
    runButtonText: deepKit.anchorOl.runButtonText,
    runningMessage: deepKit.anchorOl.runningMessage,
    collapsedView: false,
    //@ts-ignore
    isHidden: false,
    //@ts-ignore
    kiliId: null,
    executable: deepKit.anchorOl.executable,
    executionEnv: deepKit.anchorOl.executionEnv as ExecutionEnv,
    rowDecorations:
      "rowDecorations" in deepKit
        ? _initRowDecorationProcessedList(deepKit.rowDecorations)
        : [],
    objectDecorations:
      "objectDecorations" in deepKit
        ? _initObjectDecorationDollList(deepKit.objectDecorations)
        : [],
    errorDecoration: _initErrorDecorationProcessed(
      deepKit?.errorDecoration?.inputKit ?? null
    ),
    outputCols: deepKit.anchorOl.noOutputCols,
    outputFields: deepKit.anchorOl.noOutputFields,
    headers:
      deepKit.anchorOl.headers && deepKit.anchorOl.headers.length > 0
        ? JSON.parse(deepKit.anchorOl.headers)
        : null,
    credsApi: deepKit.anchorOl.runCreds?.credsApi
      ? _initCredsApiProcessed(deepKit.anchorOl.runCreds?.credsApi ?? null)
      : null,
    staticCommandSource: deepKit.anchorOl.staticCommandSource
      ? _initStaticCommandSourceProcessed(deepKit.anchorOl.staticCommandSource)
      : null,
    paramSource: deepKit.anchorOl.paramSource as ParamSource | null,
    typeSystem: deepKit.anchorOl.typeSystem as TypeSystem | null,
  };
}

function _initKitDoll6(deepKit: EDeepKit6GET): CmdProcessed {
  let dropdowns: Record<string, DropdownDoll> = {};
  if (deepKit.anchorOlId) {
    const dropdownList = deepKit.legoInstanceInputs
      .filter((lii: EDeepKit6GET_LegoInstanceInput) => lii.dropdown !== null)
      .map((lii: EDeepKit6GET_LegoInstanceInput) =>
        initDropdownDoll(lii.dropdown!)
      );
    // lmap2oGen returns an object with string keys, even if dropdownId is a number
    dropdowns = lmap2oGen(
      dropdownList,
      (dd: DropdownDoll) => dd.dropdownId,
      (dd: DropdownDoll) => dd as DropdownDoll
    );
  }
  return enforceType<CmdProcessed>({
    kitId: deepKit.kitId,
    orgId: deepKit.orgId,
    legoDoll: _initLegoDoll6(deepKit),

    name: deepKit.name,
    visibility: deepKit.visibility as KitVisibility,
    directoryId: deepKit.directoryId,
    isCopycatKit: pytruthy(deepKit.ogKitId) ? true : false,
    dropdowns: dropdowns,
    description: deepKit.description,
    dbExecuteInTransaction: deepKit.dbExecuteInTransaction ?? true,
    outputObjectPath: deepKit.outputObjectPath ?? null,
    dbInfo: deepKit.anchorOl?.dbInfo ?? null,
  });
}
function _initRecentKitDoll(r: EUserOrgKitRecentGET): RecentKitDoll {
  return {
    name: r.name,
    kitId: r.kitId ?? -1,
    isCmd: r.anchorOl !== null,
    source: r.source ?? "",
    uokId: r.uokId,
    lastViewed: r.lastViewed ?? "",
  };
}

function _initRecentKitDolls(list: EUserOrgKitRecentGET[]): RecentKitDoll[] {
  const listCopied = lcopy(list);
  const recentsFiltered = listCopied.filter((recent: any) => !recent.isHidden);
  return recentsFiltered.map(_initRecentKitDoll);
}

function _initSkinnyKitUsers(
  skinny: ESkinnyKitGET
): {
  engineers: SkinnyKitDollMember[];
  runners: SkinnyKitDollMember[];
  nonOrgAdminEngineers: boolean;
} {
  const engineers: Record<string, SkinnyKitDollMember> = {};
  const runners: Record<string, SkinnyKitDollMember> = {};
  for (const admin of skinny.org.admins.filter((a) => !a.isDeleted)) {
    engineers[admin.uoId] = {
      name: admin.user?.name ?? "Error",
      accessLevel: "org",
    };
  }
  let nonOrgAdminEngineers = false;
  for (const dirUser of (skinny?.directory?.uods ?? []).filter(
    (uod) => !(uod.uo?.isDeleted ?? false)
  )) {
    if (dirUser.uoId === null) {
      console.error("dirUser.uoId is null");
      continue;
    }
    if (dirUser.role === "admin") {
      if (!(dirUser.uoId in engineers)) {
        nonOrgAdminEngineers = true;
      }
      engineers[dirUser.uoId] = {
        name: dirUser?.uo?.user?.name ?? "Error",
        accessLevel: "dir",
      };
    } else if (dirUser.role === "runner") {
      runners[dirUser.uoId] = {
        name: dirUser.uo?.user?.name ?? "Error",
        accessLevel: "dir",
      };
    }
  }
  for (const kitUser of skinny.uoks.filter(
    (uok) => !(uok.uo?.isDeleted ?? false)
  )) {
    if (!kitUser?.uo?.uoId) {
      console.error("kitUser.uoId is null");
      continue;
    }
    if (kitUser.role === "admin") {
      if (!(kitUser.uo.uoId in engineers)) {
        nonOrgAdminEngineers = true;
      }
      engineers[kitUser.uo.uoId] = {
        name: kitUser.uo.user?.name ?? "Error",
        accessLevel: "kit",
      };
    } else if (kitUser.role === "runner") {
      runners[kitUser.uo.uoId] = {
        name: kitUser.uo.user?.name ?? "Error",
        accessLevel: "kit",
      };
    }
  }
  if (skinny.createdByUo) {
    if (!(skinny.createdByUo.uoId in engineers)) {
      nonOrgAdminEngineers = true;
    }
    engineers[skinny.createdByUo.uoId] = {
      name: skinny.createdByUo.user?.name ?? "Error",
      accessLevel: "kit",
    };
  }
  return {
    engineers: lsort(ovalues(engineers), "name"),
    runners: lsort(ovalues(runners), "name"),
    nonOrgAdminEngineers,
  };
}
function _initSkinnyKit(
  skinny: ESkinnyKitGET,
  hasAccess = true
): SkinnyKitDoll {
  const { engineers, runners, nonOrgAdminEngineers } = _initSkinnyKitUsers(
    skinny
  );
  return {
    name: skinny.name,
    kitId: skinny.kitId,
    orgId: skinny.orgId,
    isCmd: skinny.anchorOl !== null, // TODO: demarcate this better somehow?
    directoryId: skinny.directory?.directoryId ?? null,
    directoryName: skinny.directory?.name ?? null,
    cloudName: skinny.anchorOl?.name ?? null,
    visibility: skinny.visibility as KitVisibility,
    ogKitId: skinny.ogKitId ?? null,
    description: skinny.description,
    hasAccess: hasAccess,
    // punting on groups till COMC uses them
    engineerGroups: [],
    runnerGroups: [],
    engineers,
    runners,
    nonOrgAdminEngineers,
  };
}

type PartialSkinnyKit = Partial<
  Omit<ESkinnyKitGET, "directory"> & {
    directory?: { directoryId: number; name: string };
  }
>;
function _initPartialSkinnyKit(skinny: PartialSkinnyKit): SkinnyKitDoll {
  return {
    name: skinny.name ?? "",
    kitId: skinny.kitId ?? -1,
    orgId: skinny.orgId ?? "",
    isCmd: skinny.anchorOl !== null,
    directoryId: skinny.directory?.directoryId ?? null,
    directoryName: skinny.directory?.name ?? null,
    cloudName: skinny.anchorOl?.name ?? null,
    visibility: skinny.visibility as KitVisibility,
    ogKitId: skinny.ogKitId ?? null,
    description: skinny.description ?? null,
    hasAccess: true,
    engineerGroups: [],
    runnerGroups: [],
    engineers: [],
    runners: [],
    nonOrgAdminEngineers: false,
  };
}
// _initSkinnyKit({}); //=

function _initSkinnyKits(
  skinnyKits: ESkinnyKitGET[],
  hasAccess = true
): SkinnyKitDoll[] {
  return skinnyKits.map((skinny) => _initSkinnyKit(skinny, hasAccess));
}
function _initSkinnyKitOC(skinny: ESkinnyKitOutColGET): SkinnyKitDollOC {
  return {
    name: skinny.name,
    kitId: skinny.kitId,
    orgId: skinny.orgId,
    directoryId: skinny.directory?.directoryId ?? null,
    directoryName: skinny.directory?.name ?? null,
    cloudName: skinny.anchorOl?.name ?? null,
    outputColumns: (skinny.anchorOl?.noOutputCols ?? []).map(
      (oc: ESkinnyKitOutColGET_CT_OutputColumn) => ({
        noocId: oc.noOutColId,
        path: oc.path ?? "",
        pythonTypeStr: oc.pythonTypeStr,
        pyodbcInferredType: oc.pyodbcInferredType,
      })
    ),
  };
}
function _initSkinnyKitsOC(
  skinnyKits: ESkinnyKitOutColGET[]
): SkinnyKitDollOC[] {
  return skinnyKits.map(_initSkinnyKitOC);
}
function _initSkinnyKitIC(skinny: ESkinnyKitInColGET): SkinnyKitDollIC {
  return {
    name: skinny.name,
    kitId: skinny.kitId,
    orgId: skinny.orgId,
    directoryId: skinny.directory?.directoryId ?? null,
    directoryName: skinny.directory?.name ?? null,
    cloudName: skinny.anchorOl?.name ?? null,
    legoInstanceInputs: skinny.legoInstanceInputs,
  };
}
function _initSkinnyKitsIC(
  skinnyKits: ESkinnyKitInColGET[]
): SkinnyKitDollIC[] {
  return skinnyKits.map(_initSkinnyKitIC);
}
/*




8888888b.          888    888      
888   Y88b         888    888      
888    888         888    888      
888   d88P 8888b.  888888 88888b.  
8888888P"     "88b 888    888 "88b 
888       .d888888 888    888  888 
888       888  888 Y88b.  888  888 
888       "Y888888  "Y888 888  888 
                                   
                                   
                                   

*/

function _isCmd(kd: CmdProcessed) {
  return true;
}

/*

8888888b.                                                     888                  888       888                                                             
888   Y88b                                                    888                  888   o   888                                                             
888    888                                                    888                  888  d8b  888                                                             
888   d88P 8888b.  888d888 8888b.  88888b.d88b.  .d8888b      888888 .d8888b       888 d888b 888 888d888 8888b.  88888b.  88888b.   .d88b.  888d888 .d8888b  
8888888P"     "88b 888P"      "88b 888 "888 "88b 88K          888    88K           888d88888b888 888P"      "88b 888 "88b 888 "88b d8P  Y8b 888P"   88K      
888       .d888888 888    .d888888 888  888  888 "Y8888b.     888    "Y8888b.      88888P Y88888 888    .d888888 888  888 888  888 88888888 888     "Y8888b. 
888       888  888 888    888  888 888  888  888      X88 d8b Y88b.       X88      8888P   Y8888 888    888  888 888 d88P 888 d88P Y8b.     888          X88 
888       "Y888888 888    "Y888888 888  888  888  88888P' Y8P  "Y888  88888P'      888P     Y888 888    "Y888888 88888P"  88888P"   "Y8888  888      88888P' 
                                                                                                                 888      888                                
                                                                                                                 888      888                                
                                                                                                                 888      888                                

8888888b.                                                     888                  888       888                                                             
888   Y88b                                                    888                  888   o   888                                                             
888    888                                                    888                  888  d8b  888                                                             
888   d88P 8888b.  888d888 8888b.  88888b.d88b.  .d8888b      888888 .d8888b       888 d888b 888 888d888 8888b.  88888b.  88888b.   .d88b.  888d888 .d8888b  
8888888P"     "88b 888P"      "88b 888 "888 "88b 88K          888    88K           888d88888b888 888P"      "88b 888 "88b 888 "88b d8P  Y8b 888P"   88K      
888       .d888888 888    .d888888 888  888  888 "Y8888b.     888    "Y8888b.      88888P Y88888 888    .d888888 888  888 888  888 88888888 888     "Y8888b. 
888       888  888 888    888  888 888  888  888      X88 d8b Y88b.       X88      8888P   Y8888 888    888  888 888 d88P 888 d88P Y8b.     888          X88 
888       "Y888888 888    "Y888888 888  888  888  88888P' Y8P  "Y888  88888P'      888P     Y888 888    "Y888888 88888P"  88888P"   "Y8888  888      88888P' 
                                                                                                                 888      888                                
                                                                                                                 888      888                                
                                                                                                                 888      888                                

8888888b.                                                     888                  888       888                                                             
888   Y88b                                                    888                  888   o   888                                                             
888    888                                                    888                  888  d8b  888                                                             
888   d88P 8888b.  888d888 8888b.  88888b.d88b.  .d8888b      888888 .d8888b       888 d888b 888 888d888 8888b.  88888b.  88888b.   .d88b.  888d888 .d8888b  
8888888P"     "88b 888P"      "88b 888 "888 "88b 88K          888    88K           888d88888b888 888P"      "88b 888 "88b 888 "88b d8P  Y8b 888P"   88K      
888       .d888888 888    .d888888 888  888  888 "Y8888b.     888    "Y8888b.      88888P Y88888 888    .d888888 888  888 888  888 88888888 888     "Y8888b. 
888       888  888 888    888  888 888  888  888      X88 d8b Y88b.       X88      8888P   Y8888 888    888  888 888 d88P 888 d88P Y8b.     888          X88 
888       "Y888888 888    "Y888888 888  888  888  88888P' Y8P  "Y888  88888P'      888P     Y888 888    "Y888888 88888P"  88888P"   "Y8888  888      88888P' 
                                                                                                                 888      888                                
                                                                                                                 888      888                                
                                                                                                                 888      888                                

*/

/*


888     888 8888888b.  888           8888888b.                                                 
888     888 888   Y88b 888           888   Y88b                                                
888     888 888    888 888           888    888                                                
888     888 888   d88P 888           888   d88P 8888b.  888d888 8888b.  88888b.d88b.  .d8888b  
888     888 8888888P"  888           8888888P"     "88b 888P"      "88b 888 "888 "88b 88K      
888     888 888 T88b   888           888       .d888888 888    .d888888 888  888  888 "Y8888b. 
Y88b. .d88P 888  T88b  888           888       888  888 888    888  888 888  888  888      X88 
 "Y88888P"  888   T88b 88888888      888       "Y888888 888    "Y888888 888  888  888  88888P' 
                                                                                               
                                                                                               
                                                                                               
*/
const sortKitBuilderQueryParams = (
  [k1, v1]: [string, unknown],
  [k2, v2]: [string, unknown]
) => {
  if (k1 === "id") {
    return -1;
  } else if (k2 === "id") {
    return 1;
  } else if (k1 === "runId") {
    return -1;
  } else if (k2 === "runId") {
    return 1;
  } else if (k1 === "params") {
    return 1;
  } else if (k2 === "params") {
    return -1;
  } else {
    return 0;
  }
};
function _toExcelFormula(
  kd: CmdProcessed,
  origin: string,
  path: string,
  queryObj: any,
  hyperlinkText: string
) {
  // Not making a copy here since this method is read only and needs to be fast
  let allCmds: [string, LegoDoll][] = [];
  allCmds = [["", kd.legoDoll]];
  let paramQs = allCmds
    .map(([kitInstanceIdStr, ld]) =>
      schemaToExcelPreppedString(kitInstanceIdStr, ld.kitRunSchema)
    )
    .filter((qs) => qs.length !== 0)
    .join(",");
  paramQs = paramQs.replace(/%%%FLANKBLANK%%%,/g, '"&A2&",');
  paramQs = paramQs.replace(/%%%FLANKBLANK%%%$/, '"&A2&"'); // params at end
  let queryString = oitems(
    omerge(queryObj, paramQs.length > 0 ? { params: paramQs } : {})
  )
    // sort array where 'id' is first, 'runId' is second and 'params' are last
    .sort(sortKitBuilderQueryParams)
    .map(([k, v]) => `${k}=${v}`)
    .join("&");
  queryString = queryString.length > 0 ? `?${queryString}` : "";
  return `=HYPERLINK("${origin}${path}${queryString}", "${hyperlinkText}")`;
}

function _toQueryString(kd: CmdProcessed) {
  // Not making a copy here since this method is read only and needs to be fast
  let allCmds: [string, LegoDoll][] = [];
  allCmds = [["", kd.legoDoll]];
  return allCmds
    .map(([kitInstanceIdStr, ld]) =>
      schemaToQueryString(kitInstanceIdStr, ld.kitRunSchema)
    )
    .filter((qs) => qs.length !== 0)
    .join(",");
}
function _extractKitInstanceIdStrFromPath(fullPath: string): string {
  const pathParts = pathSplit(fullPath);
  if (pathParts.length > 1 && /^\d+$/.test(pathParts[0])) {
    return pathParts[0];
  }
  return "";
}
function _extractParamPath(fullPath: string) {
  const pathParts = pathSplit(fullPath);
  if (pathParts.length > 1 && /^\d+$/.test(pathParts[0])) {
    return pathsJoin(pathRest(fullPath));
  }
  return fullPath;
}

// _extractKitInstanceIdStrFromPath("456.this.is.nested"); //=
// _extractKitInstanceIdStrFromPath("blah.this.is.nested"); //=
// _extractParamPath("blah.this.is.nested"); //=
// _extractParamPath("456.this.is.nested"); //=

function _bindUrlParams(
  kd: CmdProcessed,
  urlParams: Record<string, string> | null,
  depth = 0
) {
  if (urlParams === null) {
    return kd;
  }
  const lookupByInstance = ovaluemap(
    lgroupBy(
      oitems(urlParams).map(([k, v]: [string, any]) => [
        _extractKitInstanceIdStrFromPath(k),
        _extractParamPath(k),
        v,
      ]),
      ([i, k, v]) => i
    ),
    (v: unknown) =>
      lot2o((v as [string, string, string][]).map(([i, k, v]) => [k, v]))
  );
  let c;
  if (depth == 0) {
    c = ocopy(kd);
  } else {
    c = kd;
  }
  let allCmds: [string, LegoDoll][] = [];
  allCmds = [["", c.legoDoll]];
  for (const [kitInstanceIdStr, ref] of allCmds) {
    ref.kitRunSchema = bindFlatParamsToSchema(
      ref.kitRunSchema,
      oget(lookupByInstance, kitInstanceIdStr)
    );
  }
  return c;
}

// const path =
//   "/flank-interns-1/builder?id=5221&runGroupId=1106&params=root.li_5000.job_title%3A%3A%3ARecruiter,root.li_5000.location%3A%3A%3A%22United%20States%22,root.li_5000.post_date%3A%3A%3A%22Past%20Month%22,root.li_5000.work_type%5B0%5D%3A%3A%3Aon-site,root.li_5000.job_type%5B0%5D%3A%3A%3Afull-time,root.li_5000.company_size%5B0%5D%3A%3A%3A%2211-50%20employees%22,root.li_5000.company_size%5B1%5D%3A%3A%3A%2251-200%20employees%22,root.li_5000.company_size%5B2%5D%3A%3A%3A%22501-1000%20employees%22,root.li_5000.company_size%5B3%5D%3A%3A%3A%225001-10000%20employees%22,root.li_5000.include_industries%5B0%5D%3A%3A%3AEducation,root.li_5000.exclude_staffing_agencies%3A%3A%3Atrue,root.li_5000.remove_duplicate_companies%3A%3A%3Atrue,root.li_5000.hiring_manager_job_title%3A%3A%3A%22her,her,her%22,root.li_5000.pocs_per_company%3A%3A%3A3,root.li_5000.limit_contact_per_search%3A%3A%3A20";
// const path =
//   "/flank-interns-1/builder?id=5221&runGroupId=1106&params=root.li_5000.job_title%3A%3A%3ARecruiter,root.li_5000.location%3A%3A%3AUnited%20States,root.li_5000.post_date%3A%3A%3APast%20Month,root.li_5000.work_type%5B0%5D%3A%3A%3Aon-site,root.li_5000.job_type%5B0%5D%3A%3A%3Afull-time,root.li_5000.company_size%5B0%5D%3A%3A%3A11-50%20employees,root.li_5000.company_size%5B1%5D%3A%3A%3A51-200%20employees,root.li_5000.company_size%5B2%5D%3A%3A%3A501-1000%20employees,root.li_5000.company_size%5B3%5D%3A%3A%3A5001-10000%20employees,root.li_5000.include_industries%5B0%5D%3A%3A%3AEducation,root.li_5000.exclude_staffing_agencies%3A%3A%3Atrue,root.li_5000.remove_duplicate_companies%3A%3A%3Atrue,root.li_5000.hiring_manager_job_title%3A%3A%3Aher,null%3A%3A%3Anull,root.li_5000.pocs_per_company%3A%3A%3A3,root.li_5000.limit_contact_per_search%3A%3A%3A20";
// const path =
//   "/flank-demos-1/builder?id=12634&runGroupId=4285&params=root.li_12382.job_title%3A%3A%3Ahello,root.li_12382.exclude_staffing_agencies%3A%3A%3Afalse,root.li_12382.use_flank_hm_identifier%3A%3A%3Afalse";
// const qps = pathToQueryParams(path); //=
// import pe from "./paramExamples";
// _bindUrlParams(pe.kitDoll2, qps.params); //=
// _bindUrlParams(
//   {
//     kitInstanceId: "root",
//     legoDolls: [
//       { legoInstanceId: 5, kitRunSchema: [{ key: "hi", value: "" }] },
//       { legoInstanceId: 7, kitRunSchema: [{ key: "hi", value: "" }] },
//     ],
//   },
//   { "root.li_5.hi": "1" }
// ).legoDolls[0]; //=
// https://www.flank.cloud/flank-demos-1/builder?id=9352&runGroupId=2695&params=root.ki_281.li_9203.What%20is%20it%3F%3A%3A%3A%22panda%20in%20a%20ball%20pit%22,root.ki_283.li_9205.Emotions%3A%3A%3A%22negative%20mood,%20low%20energy%22,root.ki_285.li_9207.Size%20and%20structure%3A%3A%3A%22big%20and%20structured%22,root.ki_287.li_9209.Looks%20and%20vibes%3A%3A%3A%22gothic,%20fantasy%22,root.ki_289.li_9211.Camera%20proximity%3A%3A%3A%22long%20shot%22,root.ki_291.li_9213.Camera%20position%3A%3A%3A%22overhead%20view%22,root.ki_293.li_9215.Camera%20lens%3A%3A%3A%22wide%20angle%20lens,%2015mm%22,root.ki_295.li_9217.Outdoor%20lighting%3A%3A%3Aovercast,root.ki_297.li_9219.Indoor%20lighting%3A%3A%3A%22high-key%20lighting%22,root.ki_301.li_9223.Film%20style%3A%3A%3Apolaroid,root.ki_303.li_9225.Photo%20genre%3A%3A%3A%22candid%20street%20portrait%22,root.ki_280.li_9025.what_is_it%3A%3A%3A%22panda%20in%20a%20ball%20pit%22,root.ki_280.li_9025.emotion%3A%3A%3A%22negative%20mood,%20low%20energy%22,root.ki_280.li_9025.sizey_structurey_words%3A%3A%3A%22big%20and%20structured%22,root.ki_280.li_9025.looks_and_vibes%3A%3A%3A%22gothic,%20fantasy%22,root.ki_280.li_9025.camera_proximity%3A%3A%3A%22long%20shot%22,root.ki_280.li_9025.camera_position%3A%3A%3A%22overhead%20view%22,root.ki_280.li_9025.camera_lenses%3A%3A%3A%22wide%20angle%20lens,%2015mm%22,root.ki_280.li_9025.outdoor_lighting%3A%3A%3Aovercast,root.ki_280.li_9025.indoor_lighting%3A%3A%3A%22high-key%20lighting%22,root.ki_280.li_9025.film_styles%3A%3A%3Apolaroid,root.ki_280.li_9025.photo_genre%3A%3A%3A%22candid%20street%20portrait%22,root.ki_280.li_9025.portrait_photographer%3A%3A%3A,root.ki_280.li_9025.illustration_style%3A%3A%3A,root.ki_280.li_9025.art_history_style%3A%3A%3A,root.ki_280.li_9025.statue_style%3A%3A%3A,root.ki_280.li_9025.paper_and_textiles%3A%3A%3A,root.ki_280.li_9025.ceramics_and_glass%3A%3A%3A
// _bindUrlParams(
//   {
//     kitInstanceId: "root",
//     cells: [
//       {
//         kitInstanceId: 456,
//         legoDolls: [
//           { legoInstanceId: 5, kitRunSchema: [{ key: "hi", value: "" }] },
//           { legoInstanceId: 7, kitRunSchema: [{ key: "hi", value: "" }] },
//         ],
//       },
//     ],
//   },
//   { "root.ki_456.li_5.hi": "1" }
// ).cells[0].legoDolls[0]; //=
// _bindUrlParams2(
//   {
//     kitInstanceId: "root",
//     cells: [
//       {
//         kitInstanceId: 456,
//         legoDolls: [
//           {
//             legoInstanceId: 5,
//             kitRunSchema: [
//               {
//                 key: "hi",
//                 value: "",
//                 jsonType: "object",
//                 objectPropertySchemas: [{ key: "there", value: "" }],
//               },
//             ],
//           },
//         ],
//       },
//     ],
//   },
//   { "root.ki_456.li_5.hi.there": "1" }
// ).cells[0].legoDolls[0].kitRunSchema[0].objectPropertySchemas; //=
// _bindUrlParams(
//   {
//     kitInstanceId: "root",
//     cells: [
//       {
//         kitInstanceId: 456,
//         legoDolls: [
//           {
//             legoInstanceId: 5,
//             kitRunSchema: [
//               {
//                 key: "hi",
//                 jsonType: "array",
//                 listElements: [{ value: "" }],
//               },
//             ],
//           },
//         ],
//       },
//     ],
//   },
//   { "root.ki_456.li_5.hi[0]": "1" }
// ).cells[0].legoDolls[0].kitRunSchema[0].listElements[0]; //=

type TuplePair = [any, any];

function _flattenOnceNestedTuples(
  list: Array<TuplePair | TuplePair[]>
): TuplePair[] {
  const flattened: TuplePair[] = [];

  for (const item of list) {
    if (isArray(item[0])) {
      flattened.push(...(item as TuplePair[]));
    } else {
      flattened.push(item as TuplePair);
    }
  }

  return flattened;
}

// const data = [
//   ["k1", "v1"],
//   ["k2", "v2"],
//   [
//     ["k3", "v3"],
//     ["k4", "v4"],
//   ],
// ];
// flattenOnceNestedTuples(data); //=

function _addressAmbiguousParams(
  kd: CmdProcessed,
  params: Record<string, string> | null
): Record<string, string> | null {
  if (params === null) return params;
  const list = oitems(params).map(([k, v]) => {
    if (/root\.li_\d+\..+/.test(k)) {
      // backwards compatibility
      return [pathRest(pathRest(k)), v];
    } else if (/root\.ki_\d+\.li_\d+\..+/.test(k)) {
      // backwards compatibility
      const kiPart = pathFirst(pathRest(k)).split("_")[1];
      return [pathJoin(kiPart, pathRest(pathRest(pathRest(k)))), v];
    } else {
      return [k, v];
    }
  }) as Array<TuplePair | TuplePair[]>;
  return lot2o(_flattenOnceNestedTuples(list)) as Record<string, string>;
}
// const p1 =
//   "/flank-interns-1/builder?id=2994&runGroupId=1045&params=root.li_2976.%40userId%3A%3A%3A2";
// const p =
//   "/flank-interns-1/builder?id=2994&runGroupId=1045&params=%40userIdd%3A%3A%3A2";
// pathToQueryParams(p); //=
// const sch = [
//   {
//     key: "@userId",
//     typeSystem: "mssql",
//     typeId: "int",
//     jsonType: "number",
//     component: "b-input",
//     inputType: "number",
//     objectPropertySchemas: null,
//     listElementSchema: null,
//     defaultValue: null,
//     defaultAmbiguousInput: null,
//     useDefaultValue: false,
//     lockDefaultValue: false,
//     hidden: false,
//     note: "",
//     manuallyAdded: false,
//     uuid: "2908e306-5d01-40c5-9e54-48faeba9df29",
//     listElements: null,
//     value: 2,
//     isValid: true,
//   },
// ];
// const kd = {
//   kitId: 2994,
//   cells: null,
//   legoDolls: [
//     {
//       order: 0,
//       legoInstanceId: 4979,
//       kitRunSchema: [
//         {
//           key: "@userId",
//           typeSystem: "mssql",
//           typeId: "int",
//           constraints: {
//             multipleOf: null,
//             maximum: "2147483647",
//             exclusiveMaximum: null,
//             minimum: "-2147483648",
//             exclusiveMinimum: null,
//             maxLength: 4,
//             minLength: null,
//             pattern: null,
//             maxItems: null,
//             minItems: null,
//             uniqueItems: null,
//             maxProperties: null,
//             minProperties: null,
//             required: null,
//             readOnly: null,
//             writeOnly: null,
//             nullable: null,
//             enum: null,
//             validationMessage: null,
//             step: "1",
//           },
//           jsonType: "number",
//           component: "b-input",
//           inputType: "number",
//           objectPropertySchemas: null,
//           listElementSchema: null,
//           defaultValue: null,
//           defaultAmbiguousInput: null,
//           useDefaultValue: false,
//           lockDefaultValue: false,
//           hidden: false,
//           note: "",
//           manuallyAdded: false,
//           uuid: "58f16e88-3b6b-4c3e-ae4d-4a2f4606c8ec",
//           listElements: null,
//           value: "2",
//           isValid: true,
//         },
//       ],

//       legoName: "get_users",
//       syncDescription: null,
//       directoryId: null,
//       runOnStartup: null,
//       runOnStartupValues: {},
//       runCredsId: 191,
//       syncCredsId: 191,
//       cloudId:
//         "db::mssql::fomf-sandbox-ssdb.database.windows.net::fomf-ss-sandbox-db::dbo::procedure::get_users",
//       cloudName: "get_users",
//       warningTag: null,
//       runButtonText: null,
//       collapsedView: true,
//       isHidden: false,
//       apiImageUrl: null,
//       kiliId: null,
//       executable: null,
//       executionEnv: "nol",
//     },
//     {
//       order: 1,
//       legoInstanceId: 2976,
//       kitRunSchema: [
//         {
//           key: "@userId",
//           typeSystem: "mssql",
//           typeId: "int",
//           constraints: {
//             multipleOf: null,
//             maximum: "2147483647",
//             exclusiveMaximum: null,
//             minimum: "-2147483648",
//             exclusiveMinimum: null,
//             maxLength: 4,
//             minLength: null,
//             pattern: null,
//             maxItems: null,
//             minItems: null,
//             uniqueItems: null,
//             maxProperties: null,
//             minProperties: null,
//             required: null,
//             readOnly: null,
//             writeOnly: null,
//             nullable: null,
//             enum: null,
//             validationMessage: null,
//             step: "1",
//           },
//           jsonType: "number",
//           component: "b-input",
//           inputType: "number",
//           objectPropertySchemas: null,
//           listElementSchema: null,
//           defaultValue: null,
//           defaultAmbiguousInput: null,
//           useDefaultValue: false,
//           lockDefaultValue: false,
//           hidden: false,
//           note: "",
//           manuallyAdded: false,
//           uuid: "58f16e88-3b6b-4c3e-ae4d-4a2f4606c8ec",
//           listElements: null,
//           value: "2",
//           isValid: true,
//         },
//       ],
//       legoName: "getUserAge",
//       syncDescription: null,
//       directoryId: null,
//       runOnStartup: null,
//       runOnStartupValues: {},
//       runCredsId: 191,
//       syncCredsId: 191,
//       cloudId:
//         "db::mssql::fomf-sandbox-ssdb.database.windows.net::fomf-ss-sandbox-db::dbo::procedure::getUserAge",
//       cloudName: "getUserAge",
//       warningTag: null,
//       runButtonText: null,
//       collapsedView: false,
//       isHidden: false,
//       apiImageUrl: null,
//       kiliId: null,
//       executable: null,
//       executionEnv: "nol",
//     },
//   ],
//   kitInstanceId: "root",
//   order: 0,
//   name: "getUserAge",
//   visibility: "org",
//   directoryId: null,
// };

// _addressAmbiguousParams(kd, pathToQueryParams(p).params); //=
/*


8888888b.            .d888                  888 888         888     888         888                            
888  "Y88b          d88P"                   888 888         888     888         888                            
888    888          888                     888 888         888     888         888                            
888    888  .d88b.  888888 8888b.  888  888 888 888888      Y88b   d88P 8888b.  888 888  888  .d88b.  .d8888b  
888    888 d8P  Y8b 888       "88b 888  888 888 888          Y88b d88P     "88b 888 888  888 d8P  Y8b 88K      
888    888 88888888 888   .d888888 888  888 888 888           Y88o88P  .d888888 888 888  888 88888888 "Y8888b. 
888  .d88P Y8b.     888   888  888 Y88b 888 888 Y88b.          Y888P   888  888 888 Y88b 888 Y8b.          X88 
8888888P"   "Y8888  888   "Y888888  "Y88888 888  "Y888          Y8P    "Y888888 888  "Y88888  "Y8888   88888P' 
                                                                                                               
                                                                                                               
                                                                                                               
*/
function _setDefaultValues(kd: CmdProcessed): CmdProcessed {
  const c = ocopy(kd);
  c.legoDoll.kitRunSchema = setSchemaValuesToDefaults(c.legoDoll.kitRunSchema);
  return c;
}
function _setEnvVariableValues(
  kd: CmdProcessed,
  variables: { [key: string]: any }
): CmdProcessed {
  const c = ocopy(kd);
  c.legoDoll.kitRunSchema = setSchemaValuesToVariables(
    c.legoDoll.kitRunSchema,
    variables
  );
  return c;
}

/*



8888888b.  888                        8888888b.  888                        8888888b.  888                   
888   Y88b 888                        888   Y88b 888                        888   Y88b 888                   
888    888 888                        888    888 888                        888    888 888                   
888   d88P 888  8888b.  88888b.       888   d88P 888  8888b.  88888b.       888   d88P 888  8888b.  88888b.  
8888888P"  888     "88b 888 "88b      8888888P"  888     "88b 888 "88b      8888888P"  888     "88b 888 "88b 
888        888 .d888888 888  888      888        888 .d888888 888  888      888        888 .d888888 888  888 
888        888 888  888 888  888      888        888 888  888 888  888      888        888 888  888 888  888 
888        888 "Y888888 888  888      888        888 "Y888888 888  888      888        888 "Y888888 888  888 
                                                                                                             
                                                                                                             
                                                                                                             
8888888b.  888                        8888888b.  888                        8888888b.  888                   
888   Y88b 888                        888   Y88b 888                        888   Y88b 888                   
888    888 888                        888    888 888                        888    888 888                   
888   d88P 888  8888b.  88888b.       888   d88P 888  8888b.  88888b.       888   d88P 888  8888b.  88888b.  
8888888P"  888     "88b 888 "88b      8888888P"  888     "88b 888 "88b      8888888P"  888     "88b 888 "88b 
888        888 .d888888 888  888      888        888 .d888888 888  888      888        888 .d888888 888  888 
888        888 888  888 888  888      888        888 888  888 888  888      888        888 888  888 888  888 
888        888 "Y888888 888  888      888        888 "Y888888 888  888      888        888 "Y888888 888  888 
                                                                                                             
                                                                                                             
                                                                                                             
8888888b.  888                        8888888b.  888                        8888888b.  888                   
888   Y88b 888                        888   Y88b 888                        888   Y88b 888                   
888    888 888                        888    888 888                        888    888 888                   
888   d88P 888  8888b.  88888b.       888   d88P 888  8888b.  88888b.       888   d88P 888  8888b.  88888b.  
8888888P"  888     "88b 888 "88b      8888888P"  888     "88b 888 "88b      8888888P"  888     "88b 888 "88b 
888        888 .d888888 888  888      888        888 .d888888 888  888      888        888 .d888888 888  888 
888        888 888  888 888  888      888        888 888  888 888  888      888        888 888  888 888  888 
888        888 "Y888888 888  888      888        888 "Y888888 888  888      888        888 "Y888888 888  888 
                                                                                                             

                                                                       
                                                                       
                                                                       

*/

/*


 .d8888b.                             
d88P  Y88b                            
Y88b.                                 
 "Y888b.   888  888 88888b.   .d8888b 
    "Y88b. 888  888 888 "88b d88P"    
      "888 888  888 888  888 888      
Y88b  d88P Y88b 888 888  888 Y88b.    
 "Y8888P"   "Y88888 888  888  "Y8888P 
                888                   
           Y8b d88P                   
            "Y88P"                    

            */

function _planToSync(kd: CmdProcessed): KitDollPlan {
  const legoDoll = kd.legoDoll;
  if (legoDoll === null) {
    return new KitDollPlan({ kitDoll: kd });
  }
  return new KitDollPlan({
    kitDollRequest: {
      method: HttpMethod.POST,
      path: "syncs-2",
      body: {
        olId: legoDoll.olId,
        credsId: kd.dbInfo?.dbCreds?.credsId ?? legoDoll.syncCredsId,
      },
      options: { orgPath: true },
      callback: (syncResp: SyncWrapper) => {
        if (syncResp.stage1?.error || syncResp.stage2?.error) {
          throw Error(
            pyCoalesce(syncResp.stage1?.error, syncResp.stage2?.error)
          );
        }
        return {
          method: HttpMethod.GET,
          path: `deep-kits-6/${kd.kitId}`,
          options: {
            orgPath: true,
          },
          callback: (getResp: EDeepKit6GET) => {
            return {
              kitDoll: _initKitDoll6(getResp),
            };
          },
        };
      },
    },
  });
}

/*

888     888               888          888            
888     888               888          888            
888     888               888          888            
888     888 88888b.   .d88888  8888b.  888888 .d88b.  
888     888 888 "88b d88" 888     "88b 888   d8P  Y8b 
888     888 888  888 888  888 .d888888 888   88888888 
Y88b. .d88P 888 d88P Y88b 888 888  888 Y88b. Y8b.     
 "Y88888P"  88888P"   "Y88888 "Y888888  "Y888 "Y8888  
            888                                       
            888                                       
            888                                       

*/

function _planToUpdateCredsApi(
  kd: CmdProcessed,
  credsId: number,
  payload: EInternalCredsAPIPATCHReq
) {
  const request = {
    method: HttpMethod.PATCH,
    path: `creds-api/${credsId}`,
    body: payload,
    options: { orgPath: true },
    callback: (resp: CredsAPIPATCHResp) => {
      if (!resp.triggerInputRefresh) {
        const c = ocopy(kd);
        if (c.legoDoll.credsApi) {
          c.legoDoll.credsApi.authType = payload.authType ?? null;
          c.legoDoll.credsApi.customHeaders = payload.customHeaders
            ? JSON.parse(payload.customHeaders)
            : null;
          c.legoDoll.credsApi.usernameSource = payload.usernameSource ?? null;
          c.legoDoll.credsApi.passwordSource = payload.passwordSource ?? null;
          c.legoDoll.credsApi.username = payload.username ?? null;
          c.legoDoll.credsApi.password = payload.password ?? null;
          c.legoDoll.credsApi.bearerToken = payload.bearerToken ?? null;
        }
        return {
          kitDoll: c,
        };
      } else {
        return {
          method: HttpMethod.GET,
          path: `deep-kits-6/${kd.kitId}`,
          options: { orgPath: true },
          callback: (resp: EDeepKit6GET) => {
            return {
              kitDoll: _initKitDoll6(resp),
            };
          },
        };
      }
    },
  };
  return new KitDollPlan({
    kitDollRequest: request,
  });
}
function _planToUpdateDbInfo(
  cmd: CmdProcessed,
  payload: ECmdTemplateDbPATCHReq
): KitDollPlan {
  const request = {
    method: HttpMethod.PATCH,
    path: `command-templates-db/${cmd.legoDoll.olId}`,
    body: payload,
    options: { orgPath: true },
    callback: (resp: ECmdTemplateDbGET) => {
      const c = ocopy(cmd);
      c.dbInfo = resp;
      return { kitDoll: c };
    },
  };
  return new KitDollPlan({
    kitDollRequest: request,
  });
}
function _planToUpdateLego(
  kd: CmdProcessed,
  olId: string,
  payload: ECmdTemplatePATCHReq,
  descriptionChanged = false,
  newDescription: string | null = null,
  dbExecuteInTransactionChanged = false,
  newDbExecuteInTransaction: boolean,
  nameChanged = false,
  newName: string | null = null,
  outputObjectPathChanged = false,
  newOutputObjectPath: string | null = null
): KitDollPlan {
  const c = ocopy(kd);
  const parallelRequests = [] as ApiRequest[];
  parallelRequests.push({
    method: HttpMethod.PATCH,
    path: `command-templates/${olId}`,
    body: payload,
    options: { orgPath: true },
  });
  console.log("payload", payload); //=
  if (nameChanged) {
    parallelRequests.push({
      method: HttpMethod.PATCH,
      path: `kits/${c.kitId}`,
      body: enforceType<EKitPATCHReq>({ name: newName ?? "" }),
      options: { orgPath: true },
    });
    c.name = newName ?? "";
  }
  // Hacky AF
  if (descriptionChanged) {
    parallelRequests.push({
      method: HttpMethod.PATCH,
      path: `kits/${c.kitId}`,
      body: enforceType<EKitPATCHReq>({ description: newDescription }),
      options: { orgPath: true },
    });
    c.description = newDescription;
  }
  if (dbExecuteInTransactionChanged) {
    parallelRequests.push({
      method: HttpMethod.PATCH,
      path: `kits/${c.kitId}`,
      body: enforceType<EKitPATCHReq>({
        dbExecuteInTransaction: newDbExecuteInTransaction,
      }),
      options: { orgPath: true },
    });
    c.dbExecuteInTransaction = newDbExecuteInTransaction;
  }
  if (outputObjectPathChanged) {
    if (newOutputObjectPath === "") {
      newOutputObjectPath = null;
    }
    parallelRequests.push({
      method: HttpMethod.PATCH,
      path: `kits/${c.kitId}`,
      body: enforceType<EKitPATCHReq>({
        outputObjectPath: newOutputObjectPath,
      }),
      options: { orgPath: true },
    });
    c.outputObjectPath = newOutputObjectPath;
  }
  if ("headers" in payload && payload.headers) {
    payload.headers = JSON.parse(payload.headers);
  }
  c.legoDoll = omerge(c.legoDoll, payload);

  return new KitDollPlan({
    kitDoll: c,
    parallelRequests,
  });
}
function _planToUpdateLegoOld(
  kd: CmdProcessed,
  old: LegoDoll,
  updated: LegoDoll
): KitDollPlan {
  const c = ocopy(kd);
  const [l, r] = odiffOldNew(old, updated, 0);
  const diff = r;
  if (pyfalsey(diff)) {
    return new KitDollPlan({ kitDoll: c });
  }

  const parallelRequests = [] as ApiRequest[];
  const legoFields = [
    "legoName",
    "syncDescription",
    "warningTag",
    "runButtonText",
    "runningMessage",
    "runOnStartup",
    "runOnStartupValues",
  ];
  const kitFields = ["directoryId"];
  const legoInstanceFields = ["kitRunSchema"];
  const legoDiff = okeyfilter(diff, (k) => legoFields.includes(k));
  const kitDiff = okeyfilter(diff, (k) => kitFields.includes(k));
  const legoInstanceDiff = okeyfilter(diff, (k) =>
    legoInstanceFields.includes(k)
  );
  // console.log("diff", diff); //=
  // console.log("legoInstanceDiff", legoInstanceDiff); //=
  // console.log("kitRunSchema l", l.kitRunSchema); //=
  if (pytruthy(legoDiff)) {
    parallelRequests.push({
      method: HttpMethod.PATCH,
      path: `command-templates/${updated.olId}`,
      body: omerge(
        "legoName" in diff ? { overrideName: diff.legoName } : {},
        "syncDescription" in diff ? { description: diff.syncDescription } : {},
        "warningTag" in diff ? { warningTag: diff.warningTag } : {},
        "runButtonText" in diff ? { runButtonText: diff.runButtonText } : {},
        "runningMessage" in diff ? { runningMessage: diff.runningMessage } : {},
        "runOnStartup" in diff ? { runOnStartup: diff.runOnStartup } : {},
        "runOnStartupValues" in diff
          ? {
              runOnStartupValues: runramsToStr(diff.runOnStartupValues),
            }
          : {}
      ),
      options: { orgPath: true },
    });
    if ("legoName" in diff) {
      parallelRequests.push({
        method: HttpMethod.PATCH,
        path: `kits/${c.kitId}`,
        body: enforceType<EKitPATCHReq>({ name: diff.legoName }),
        options: { orgPath: true },
      });
      c.name = diff.legoName;
    }
  }
  if (pytruthy(kitDiff)) {
    if (c.legoDoll.olId === updated.olId) {
      parallelRequests.push({
        method: HttpMethod.PATCH,
        path: `kits/${c.kitId}`,
        body: enforceType<EKitPATCHReq>({ directoryId: diff.directoryId }),
        options: { orgPath: true },
      });
      c.directoryId = diff.directoryId;
    }
  }
  let kitDollRequest = null as ApiRequest | null;
  if (pytruthy(legoInstanceDiff)) {
    const updatedInstanceSchema = trimDownSchema(updated.kitRunSchema, {
      from: "kitrun",
      to: "instance",
    });
    const oldInstanceSchema = trimDownSchema(old.kitRunSchema, {
      from: "kitrun",
      to: "instance",
    });
    const [inOldNotNew, inNewNotOld] = ldiffOrderInsensitive(
      oldInstanceSchema,
      updatedInstanceSchema,
      "key",
      "key"
    );
    const [inputsToAdd, inputsToUpdate] = lsplit(
      updatedInstanceSchema.map((el, i): [InstanceSchemaElement, number] => [
        el,
        i,
      ]),
      ([el, i]: [InstanceSchemaElement, number]) =>
        el.legoInstanceInputId === -1
    );
    const deleteRequests = inOldNotNew.map((element: InstanceSchemaElement) => {
      return {
        method: HttpMethod.DELETE,
        path: `kits/${c.kitId}/li-inputs/${element.legoInstanceInputId}`,
        options: { orgPath: true },
      };
    });
    parallelRequests.push(...deleteRequests);

    if (inputsToAdd.length > 0) {
      kitDollRequest = {
        method: HttpMethod.POST,
        path: `kits/${c.kitId}/lego-instance-inputs`,
        body: inputsToAdd.map(([el, i]: [InstanceSchemaElement, number]) => {
          return enforceType<ELegoInstanceInputPOSTReq>(
            omerge(instanceElementToLegoInstanceInputRow(el, i), {
              legoInstanceId: null,
              legoInput: enforceType<ELegoInstanceInputPOSTReq_LegoInput>(
                instanceElementToLegoInputRow(el, c.legoDoll.olId, i)
              ),
              kitId: c.kitId,
            })
          );
        }),
        callback: (resp: ELegoInstanceInputPOSTReq[]) => {
          c.legoDoll = updated;
          for (const [lii, el] of lzipBy(
            resp,
            c.legoDoll.kitRunSchema,
            (a, b) => a.key === b.key,
            {
              keepLeft: false,
              keepRight: false,
            }
          )) {
            el.legoInstanceInputId = lii.legoInstanceInputId;
            el.legoInputId = lii.legoInputId;
          }
          return { kitDoll: c };
        },
        options: { orgPath: true, isList: true },
      };
    }
  }

  if (kitDollRequest) {
    return new KitDollPlan({
      kitDollRequest: kitDollRequest,
      parallelRequests,
    });
  } else {
    c.legoDoll = updated;
    return new KitDollPlan({
      kitDoll: c,
      parallelRequests,
    });
  }
}

/*

 .d8888b.           888                                      
d88P  Y88b          888                                      
Y88b.               888                                      
 "Y888b.    .d8888b 88888b.   .d88b.  88888b.d88b.   8888b.  
    "Y88b. d88P"    888 "88b d8P  Y8b 888 "888 "88b     "88b 
      "888 888      888  888 88888888 888  888  888 .d888888 
Y88b  d88P Y88b.    888  888 Y8b.     888  888  888 888  888 
 "Y8888P"   "Y8888P 888  888  "Y8888  888  888  888 "Y888888 
                                                             
                                                             
                                                             

*/
function _planToUpdateSchemaElement(
  kd: CmdProcessed,
  element: KitRunSchemaElement,
  kitInstanceId: number | null,
  skipDB = false
): KitDollPlan {
  // somewhere in here
  const c = ocopy(kd);
  const ref = c.legoDoll;
  if (ref === null) {
    return new KitDollPlan({ kitDoll: c });
  }
  if (element.defaultValue === "flankEmptySentinel") {
    const elementCopy = ocopy(element);
    elementCopy.defaultValue = null;
    ref.kitRunSchema = lreplace(
      ref.kitRunSchema,
      elementCopy,
      "legoInstanceInputId"
    );
  } else {
    ref.kitRunSchema = lreplace(
      ref.kitRunSchema,
      element,
      "legoInstanceInputId"
    );
  }
  if (skipDB) {
    return new KitDollPlan({ kitDoll: c });
  }
  const parallelRequests = [] as ApiRequest[];
  parallelRequests.push({
    method: HttpMethod.PATCH,
    path: `kits/${c.kitId}/li-inputs/${element.legoInstanceInputId}`,
    body: enforceType<ELegoInstanceInputPATCHReq>(
      instanceElementToLegoInstanceInputRow(
        lfirst(
          trimDownSchema([element], {
            from: "kitrun",
            to: "instance",
          })
        )
      )
    ),
    options: { orgPath: true },
  });
  return new KitDollPlan({ kitDoll: c, parallelRequests: parallelRequests });
}

// _planToUpdateSchemaElement(
//   {
//     kitInstanceId: "root",
//     kitId: 7,
//     legoDolls: [
//       {
//         legoInstanceId: 123,
//         kitRunSchema: [{ key: "name", value: "Jeremiah" }],
//       },
//     ],
//   },
//   { key: "name", value: "Jeffrey" },
//   "root.li_123",
//   "name"
// ).kitDoll.legoDolls[0]; //=

function _planToReorderSchema(
  cmd: CmdProcessed,
  fromIndex: number,
  toIndex: number
) {
  const c = ocopy(cmd);
  const list = c.legoDoll.kitRunSchema;
  const moved = list.splice(fromIndex, 1)[0];
  list.splice(toIndex, 0, moved);

  const parallelRequests = [] as ApiRequest[];
  // Only update elements between fromIndex and toIndex (inclusive)
  const startIdx = Math.min(fromIndex, toIndex);
  const endIdx = Math.max(fromIndex, toIndex);

  for (const [idx, el] of lenumerate(list).slice(startIdx, endIdx + 1)) {
    el.order = idx;
    parallelRequests.push({
      method: HttpMethod.PATCH,
      path: `kits/${c.kitId}/li-inputs/${el.legoInstanceInputId}`,
      body: enforceType<ELegoInstanceInputPATCHReq>({
        legoInstanceInputId: el.legoInstanceInputId,
        order: el.order,
      }),
      options: { orgPath: true },
    });
  }
  return new KitDollPlan({ kitDoll: c, parallelRequests: parallelRequests });
}
function _planToUpdateSchema(
  kd: CmdProcessed,
  schema: KitRunSchemaElement[],
  kitInstanceId: number | null,
  differentOrgId = "",
  skipDB = false
): KitDollPlan {
  const c = ocopy(kd);
  c.legoDoll.kitRunSchema = schema;
  if (skipDB) {
    return new KitDollPlan({ kitDoll: c });
  }
  const instanceSchema = trimDownSchema(c.legoDoll.kitRunSchema, {
    from: "kitrun",
    to: "instance",
  });
  const elementPatches = instanceSchema.map(
    (element: InstanceSchemaElement) => {
      return {
        method: HttpMethod.PATCH,
        path: `kits/${c.kitId}/li-inputs/${element.legoInstanceInputId}`,
        body: enforceType<ELegoInstanceInputPATCHReq>(
          instanceElementToLegoInstanceInputRow(element)
        ),
        options: { orgPath: true, orgId: differentOrgId },
      };
    }
  );
  return new KitDollPlan({
    kitDoll: c,
    parallelRequests: elementPatches,
  });
}
function _planToUpdateLegoInstanceInput(
  kd: CmdProcessed,
  legoInstanceInputId: number,
  partialLii: ELegoInstanceInputPATCHReq,
  {
    clearValue = false,
    kdCallback = (kd: CmdProcessed, lii: ELegoInstanceInputGET) => kd,
  }: {
    clearValue?: boolean;
    kdCallback?: (kd: CmdProcessed, lii: ELegoInstanceInputGET) => CmdProcessed;
  } = {}
): KitDollPlan {
  const c = ocopy(kd);
  const elementRef = lfind(
    c.legoDoll.kitRunSchema,
    (element) => element.legoInstanceInputId === legoInstanceInputId
  );
  if (!elementRef) {
    throw new Error("elementRef not found");
  }
  return new KitDollPlan({
    kitDollRequest: {
      method: HttpMethod.PATCH,
      path: `kits/${c.kitId}/li-inputs/${legoInstanceInputId}`,
      body: partialLii,
      options: { orgPath: true },
      callback: (resp: ELegoInstanceInputGET) => {
        const element = legoInstanceInputToInstanceSchemaElement(resp);
        Object.assign(elementRef, element);
        if (clearValue) {
          elementRef.value = elementEmptyValue(elementRef);
        }
        return {
          kitDoll: kdCallback(c, resp),
        };
      },
    },
  });
}
function _planToAddLegoInput(
  cmd: CmdProcessed,
  inputToAdd: {
    key: string;
    typeSystem: TypeSystem;
    typeId: string;
    order: number;
  }
) {
  const element = initElement(
    null,
    { from: null, to: "instance" },
    { key: inputToAdd.key }
  );
  element.typeSystem = inputToAdd.typeSystem;
  element.typeId = inputToAdd.typeId;
  element.order = inputToAdd.order;
  const computedFields = getTypeObject(
    inputToAdd.typeSystem,
    inputToAdd.typeId
  );
  if (computedFields) {
    element.constraints.minimum = pyCoalesce(computedFields.minimum, null);
    element.constraints.maximum = pyCoalesce(computedFields.maximum, null);
    element.constraints.maxLength = sToNumber(computedFields.maxLength, null);
    element.constraints.pattern = pyCoalesce(computedFields.pattern, null);
    element.jsonType = computedFields.jsonType;
    element.component = computedFields.component;
    element.inputType = computedFields.inputType;
    element.constraints.step = pyCoalesce(computedFields.step, null);
    element.constraints.validationMessage = pyCoalesce(
      computedFields.validationMessage,
      null
    );
  }
  const c = ocopy(cmd);
  const kitDollRequest = {
    method: HttpMethod.POST,
    path: `kits/${c.kitId}/lego-instance-inputs`,
    body: enforceType<ELegoInstanceInputPOSTReq>(
      omerge(instanceElementToLegoInstanceInputRow(element), {
        legoInstanceId: null,
        legoInput: enforceType<ELegoInstanceInputPOSTReq_LegoInput>(
          instanceElementToLegoInputRow(
            element,
            c.legoDoll.olId,
            inputToAdd.order
          )
        ),
        kitId: c.kitId,
      })
    ),
    callback: (resp: ELegoInstanceInputPOSTResp) => {
      const element = legoInstanceInputToInstanceSchemaElement(resp);
      c.legoDoll.kitRunSchema = lInsertAt(
        c.legoDoll.kitRunSchema,
        inputToAdd.order,
        element
      );
      return { kitDoll: c };
    },
    options: { orgPath: true },
  };

  return new KitDollPlan({
    kitDollRequest: kitDollRequest,
  });
}
function _planToDeleteLegoInput(cmd: CmdProcessed, legoInputId: number) {
  const c = ocopy(cmd);
  c.legoDoll.kitRunSchema = c.legoDoll.kitRunSchema.filter(
    (el) => el.legoInputId !== legoInputId
  );
  const parallelRequests = [
    {
      method: HttpMethod.DELETE,
      path: `kits/${c.kitId}/lego-inputs/${legoInputId}`,
      options: { orgPath: true },
    },
  ];
  return new KitDollPlan({
    kitDoll: c,
    parallelRequests: parallelRequests,
  });
}
function _planToBulkEditLegoInstanceInputs(
  cmd: CmdProcessed,
  body: EBulkLegoInstanceInputPATCHReq
): KitDollPlan {
  const c = ocopy(cmd);
  const parallelRequests = [
    {
      method: HttpMethod.PATCH,
      path: `kits/${c.kitId}/bulk-lego-instance-inputs`,
      body: body,
      options: { orgPath: true },
    },
  ];
  for (const [existing, update] of lzipBy(
    c.legoDoll.kitRunSchema,
    body.legoInstanceInputs ?? [],
    (a, b) => a.legoInstanceInputId === b.legoInstanceInputId
  )) {
    Object.assign(existing, update);
  }
  return new KitDollPlan({
    kitDoll: c,
    parallelRequests: parallelRequests,
  });
}

// 8888888b.                                888
// 888  "Y88b                               888
// 888    888                               888
// 888    888 888d888 .d88b.  88888b.   .d88888  .d88b.  888  888  888 88888b.
// 888    888 888P"  d88""88b 888 "88b d88" 888 d88""88b 888  888  888 888 "88b
// 888    888 888    888  888 888  888 888  888 888  888 888  888  888 888  888
// 888  .d88P 888    Y88..88P 888 d88P Y88b 888 Y88..88P Y88b 888 d88P 888  888
// 8888888P"  888     "Y88P"  88888P"   "Y88888  "Y88P"   "Y8888888P"  888  888
//                            888
//                            888
//                            888
function _planToUpdateDropdown(
  kd: CmdProcessed,
  dropdownId: number,
  legoInstanceInputId: number,
  body: EDropdownPATCHReq
): KitDollPlan {
  // TODO: if two elements in the same kit share a dropdown, this won't update both of them...
  const c = ocopy(kd);
  const elementRef = lfind(
    c.legoDoll.kitRunSchema,
    (el) => el.legoInstanceInputId === legoInstanceInputId
  );
  if (!elementRef) {
    throw new Error("elementRef not found");
  }
  if (
    "enum" in body &&
    !lcontains(JSON.parse(body?.enum ?? "[]"), elementRef.value, {
      looseEquality: true,
    })
  ) {
    elementRef.value = elementEmptyValue(elementRef);
  }
  const patch = {
    method: HttpMethod.PATCH,
    path: `dropdowns/${dropdownId}`,
    body: body,
    options: { orgPath: true },
    callback: (resp: EDropdownGET) => {
      const ddDoll = initDropdownDoll(resp);
      c.dropdowns[ddDoll.dropdownId] = ddDoll;
      return { kitDoll: c };
    },
  };
  return new KitDollPlan({ kitDollRequest: patch });
}
function _planToCreateDropdown(
  kd: CmdProcessed,
  enumArray: string[] | null,
  legoInstanceInputId: number,
  orgId: string,
  name: string,
  componentId: "b-select" | "b-autocomplete" | "b-radio",
  dynamicFields = {
    senderKitId: null,
    senderValueNoocId: null,
    senderDisplayNoocId: null,
    cacheInterval: null,
  } as {
    senderKitId: number | null;
    senderValueNoocId: number | null;
    senderDisplayNoocId: number | null;
    cacheInterval: "weekly" | "monthly" | null;
  }
): KitDollPlan {
  const c = ocopy(kd);

  const elementRef = lfind(
    c.legoDoll.kitRunSchema,
    (el) => el.legoInstanceInputId === legoInstanceInputId
  );
  if (!elementRef) {
    throw new Error("elementRef not found");
  }

  const dropdownPOST = {
    method: HttpMethod.POST,
    path: `dropdowns`,
    body: enforceType<EDropdownPOSTReq>({
      ...{
        name: name,
        enum: enumArray === null ? null : JSON.stringify(enumArray),
        orgId: orgId,
      },
      ...dynamicFields,
      componentId,
    }),
    options: { orgPath: true },
    callback: (ddResp: EDropdownPOSTResp) => {
      return {
        method: HttpMethod.PATCH,
        path: `kits/${c.kitId}/li-inputs/${legoInstanceInputId}`,
        body: enforceType<ELegoInstanceInputPATCHReq>({
          dropdownId: ddResp.dropdownId,
        }),
        options: { orgPath: true, orgId: orgId },
        callback: (resp: ELegoInstanceInputGET) => {
          const element = legoInstanceInputToInstanceSchemaElement(resp);
          Object.assign(elementRef, element);
          if (
            !lcontains(enumArray ?? [], elementRef.value, {
              looseEquality: true,
            })
          ) {
            elementRef.value = elementEmptyValue(elementRef);
          }
          if (resp.dropdown) {
            const ddDoll = initDropdownDoll(resp.dropdown);
            c.dropdowns[ddDoll.dropdownId] = ddDoll;
          }
          return { kitDoll: c };
        },
      };
    },
  };
  return new KitDollPlan({ kitDollRequest: dropdownPOST });
}
function _refreshDropdownsCallback(
  c: CmdProcessed,
  lii: ELegoInstanceInputGET
) {
  const ddDollIds: string[] = lunique(
    c.legoDoll.kitRunSchema
      .filter((el) => el.dropdownId !== null)
      .map((el) => (el.dropdownId as number).toString())
  );
  const [missing, toDelete] = ldiffOrderInsensitive(
    ddDollIds,
    okeysGen(c.dropdowns)
  );
  for (const ddId of toDelete) {
    delete c.dropdowns[ddId];
  }
  if (lii.dropdown?.dropdownId) {
    const liiDdDoll = initDropdownDoll(lii.dropdown);
    if (lcontains(missing, liiDdDoll.dropdownId.toString())) {
      c.dropdowns[liiDdDoll.dropdownId] = liiDdDoll;
    } else if (
      liiDdDoll.dropdownId in c.dropdowns &&
      !equals(liiDdDoll, c.dropdowns[liiDdDoll.dropdownId])
    ) {
      c.dropdowns[liiDdDoll.dropdownId] = liiDdDoll;
    }
  }
  return c;
}
function _planToUnlinkDropdown(
  kd: CmdProcessed,
  legoInstanceInputId: number
): KitDollPlan {
  return _planToUpdateLegoInstanceInput(
    kd,
    legoInstanceInputId,
    { dropdownId: null },
    { clearValue: false, kdCallback: _refreshDropdownsCallback }
  );
}
function _planToLinkDropdown(
  kd: CmdProcessed,
  legoInstanceInputId: number,
  dropdownId: number,
  { clearValue }: { clearValue?: boolean }
): KitDollPlan {
  return _planToUpdateLegoInstanceInput(
    kd,
    legoInstanceInputId,
    { dropdownId: dropdownId },
    { clearValue: clearValue, kdCallback: _refreshDropdownsCallback }
  );
}
/*

8888888                                    888    
  888                                      888    
  888                                      888    
  888   88888b.  .d8888b   .d88b.  888d888 888888 
  888   888 "88b 88K      d8P  Y8b 888P"   888    
  888   888  888 "Y8888b. 88888888 888     888    
  888   888  888      X88 Y8b.     888     Y88b.  
8888888 888  888  88888P'  "Y8888  888      "Y888 
                                                  
                                                  
                                                  

*/
function _planToUpdateDirectory(
  kd: CmdProcessed,
  directoryId: number | null
): KitDollPlan {
  const c = ocopy(kd);
  const directoryPatch: ApiRequest = {
    method: HttpMethod.PATCH,
    path: `kits/${kd.kitId}`,
    body: enforceType<EKitPATCHReq>({ directoryId: directoryId }),
    options: { orgPath: true },
  };
  c.directoryId = directoryId;
  if (_isCmd(c)) {
    (c as CmdProcessed).legoDoll.directoryId = directoryId;
  }
  return new KitDollPlan({
    kitDoll: c,
    parallelRequests: [directoryPatch],
  });
}

/*

888     888 d8b          d8b 888      d8b 888 d8b 888             
888     888 Y8P          Y8P 888      Y8P 888 Y8P 888             
888     888                  888          888     888             
Y88b   d88P 888 .d8888b  888 88888b.  888 888 888 888888 888  888 
 Y88b d88P  888 88K      888 888 "88b 888 888 888 888    888  888 
  Y88o88P   888 "Y8888b. 888 888  888 888 888 888 888    888  888 
   Y888P    888      X88 888 888 d88P 888 888 888 Y88b.  Y88b 888 
    Y8P     888  88888P' 888 88888P"  888 888 888  "Y888  "Y88888 
                                                              888 
                                                         Y8b d88P 
                                                          "Y88P"  
*/

// TODO - Figure out whether to deprecate this
// (we now just make the API call in the side panel, for USSP)
// I think the SP should own the API call, but should it own the KB update too...?
// KB still uses this for the CcSP update
function _planToUpdateVisibility(kd: CmdProcessed, visibility: KitVisibility) {
  const request = {
    method: HttpMethod.PATCH,
    path: `kits/${kd.kitId}`,
    body: enforceType<EKitPATCHReq>({ visibility: visibility }),
    options: { orgPath: true },
  };
  const c = ocopy(kd);
  c.visibility = visibility;

  return new KitDollPlan({ kitDoll: c, parallelRequests: [request] });
}

// 8888888b.                                            888    d8b
// 888  "Y88b                                           888    Y8P
// 888    888                                           888
// 888    888  .d88b.   .d8888b .d88b.  888d888 8888b.  888888 888  .d88b.  88888b.
// 888    888 d8P  Y8b d88P"   d88""88b 888P"      "88b 888    888 d88""88b 888 "88b
// 888    888 88888888 888     888  888 888    .d888888 888    888 888  888 888  888
// 888  .d88P Y8b.     Y88b.   Y88..88P 888    888  888 Y88b.  888 Y88..88P 888  888
// 8888888P"   "Y8888   "Y8888P "Y88P"  888    "Y888888  "Y888 888  "Y88P"  888  888

function _planToCreateDecoration(
  kd: CmdProcessed,
  body: ERowDecorationPOSTReq
) {
  const request = {
    method: HttpMethod.POST,
    path: `kits/${kd.kitId}/decorations`,
    body: body,
    options: { orgPath: true },
    callback: (postResp: ERowDecorationPOSTResp) => {
      return {
        method: HttpMethod.GET,
        path: `kits/${kd.kitId}/decorations/${postResp.decorationId}`,
        options: { orgPath: true },
        callback: (getResp: ERowDecorationGET) => {
          const rowDecorationProcessed = _initRowDecorationProcessed(getResp);
          const c = ocopy(kd);
          c.legoDoll.rowDecorations.push(rowDecorationProcessed);
          return { kitDoll: c, rowDecorationProcessed: rowDecorationProcessed };
        },
      };
    },
  };
  return new KitDollPlan({ kitDollRequest: request });
}
function _planToCreateObjectDecoration(
  kd: CmdProcessed,
  body: EObjectDecorationPOSTReq
) {
  const request = {
    method: HttpMethod.POST,
    path: `kits/${kd.kitId}/object-decorations`,
    body: body,
    options: { orgPath: true },
    callback: (postResp: EObjectDecorationPOSTResp) => {
      return {
        method: HttpMethod.GET,
        path: `kits/${kd.kitId}/object-decorations/${postResp.objectDecorationId}`,
        options: { orgPath: true },
        callback: (getResp: EObjectDecorationGET) => {
          const objectDecorationDoll = _initObjectDecorationDoll(getResp);
          const c = ocopy(kd);
          c.legoDoll.objectDecorations.push(objectDecorationDoll);
          return { kitDoll: c, objectDecorationDoll: objectDecorationDoll };
        },
      };
    },
  };
  return new KitDollPlan({ kitDollRequest: request });
}
function _planToCreateErrorDecoration(
  kd: CmdProcessed,
  body: EErrorDecorationPOSTReq
) {
  const request = {
    method: HttpMethod.POST,
    path: `kits/${kd.kitId}/error-decorations`,
    body: body,
    options: { orgPath: true },
    callback: (postResp: EErrorDecorationPOSTResp) => {
      return {
        method: HttpMethod.GET,
        path: `kits/${kd.kitId}/error-decorations/${kd.kitId}`,
        options: { orgPath: true },
        callback: (getResp: EErrorDecorationGET) => {
          const errorDecorationProcessed = _initErrorDecorationProcessed(
            getResp.inputKit
          );
          const c = ocopy(kd);
          c.legoDoll.errorDecoration = errorDecorationProcessed;
          return { kitDoll: c };
        },
      };
    },
  };
  return new KitDollPlan({ kitDollRequest: request });
}
function _planToDeleteDecoration(kd: CmdProcessed, decorationId: number) {
  const parallelRequest = {
    method: HttpMethod.DELETE,
    path: `kits/${kd.kitId}/decorations/${decorationId}`,
    options: { orgPath: true },
  };
  const c = ocopy(kd);
  c.legoDoll.rowDecorations = c.legoDoll.rowDecorations.filter(
    (d: RowDecorationProcessed) => d.decorationId !== decorationId
  );
  return new KitDollPlan({ kitDoll: c, parallelRequests: [parallelRequest] });
}

function _planToDeleteObjectDecoration(
  kd: CmdProcessed,
  objectDecorationId: number
) {
  const parallelRequest = {
    method: HttpMethod.DELETE,
    path: `kits/${kd.kitId}/object-decorations/${objectDecorationId}`,
    options: { orgPath: true },
  };
  const c = ocopy(kd);
  c.legoDoll.objectDecorations = c.legoDoll.objectDecorations.filter(
    (d: ObjectDecorationProcessed) =>
      d.objectDecorationId !== objectDecorationId
  );
  return new KitDollPlan({ kitDoll: c, parallelRequests: [parallelRequest] });
}

function _planToDeleteErrorDecoration(kd: CmdProcessed) {
  const parallelRequest = {
    method: HttpMethod.DELETE,
    path: `kits/${kd.kitId}/error-decorations/${kd.kitId}`,
    options: { orgPath: true },
  };
  const c = ocopy(kd);
  c.legoDoll.errorDecoration = null;
  return new KitDollPlan({ kitDoll: c, parallelRequests: [parallelRequest] });
}

function _planToSwapErrorDecoration(
  kd: CmdProcessed,
  body: EErrorDecorationPOSTReq
) {
  const request = {
    method: HttpMethod.DELETE,
    path: `kits/${kd.kitId}/error-decorations/${kd.kitId}`,
    options: { orgPath: true },
    callback: (resp: EErrorDecorationDELETEResp) => {
      return {
        method: HttpMethod.POST,
        path: `kits/${kd.kitId}/error-decorations`,
        body: body,
        options: { orgPath: true },
        callback: (resp: EErrorDecorationPOSTResp) => {
          return {
            method: HttpMethod.GET,
            path: `kits/${kd.kitId}/error-decorations/${kd.kitId}`,
            options: { orgPath: true },
            callback: (resp: EErrorDecorationGET) => {
              const errorDecorationProcessed = _initErrorDecorationProcessed(
                resp.inputKit
              );
              const c = ocopy(kd);
              c.legoDoll.errorDecoration = errorDecorationProcessed;
              return { kitDoll: c };
            },
          };
        },
      };
    },
  };
  return new KitDollPlan({ kitDollRequest: request });
}

function _planToUpdateDecoration(
  kd: CmdProcessed,
  decorationId: number,
  update: ERowDecorationPATCHReq
) {
  const c = ocopy(kd);
  const kitDollRequest = {
    method: HttpMethod.PATCH,
    path: `kits/${kd.kitId}/decorations/${decorationId}`,
    body: update,
    options: { orgPath: true },
    callback: (patchResp: ERowDecorationGET) => {
      c.legoDoll.rowDecorations = lreplace(
        c.legoDoll.rowDecorations,
        _initRowDecorationProcessed(patchResp),
        "decorationId"
      );
      return { kitDoll: c };
    },
  };
  return new KitDollPlan({ kitDollRequest: kitDollRequest });
}
function _planToUpdateObjectDecoration(
  kd: CmdProcessed,
  objectDecorationId: number,
  update: EObjectDecorationPATCHReq
) {
  const c = ocopy(kd);
  const kitDollRequest = {
    method: HttpMethod.PATCH,
    path: `kits/${kd.kitId}/object-decorations/${objectDecorationId}`,
    body: update,
    options: { orgPath: true },
    callback: (patchResp: EObjectDecorationGET) => {
      c.legoDoll.objectDecorations = lreplace(
        c.legoDoll.objectDecorations,
        _initObjectDecorationDoll(patchResp),
        "objectDecorationId"
      );
      return { kitDoll: c };
    },
  };
  return new KitDollPlan({ kitDollRequest: kitDollRequest });
}
function _planToUpdateOutputColumns(kd: CmdProcessed, olId: string) {
  const request = {
    method: HttpMethod.GET,
    path: `kits/${kd.kitId}/ols/${olId}/output-cols`,
    options: { orgPath: true },
    callback: (getResp: EOutputColumnGET[]) => {
      kd.legoDoll.outputCols = getResp;
      return { kitDoll: kd };
    },
  };
  return new KitDollPlan({ kitDollRequest: request });
}
function _planToUpdateOutputFields(kd: CmdProcessed, olId: string) {
  const request = {
    method: HttpMethod.GET,
    path: `kits/${kd.kitId}/ols/${olId}/output-fields`,
    options: { orgPath: true },
    callback: (getResp: EOutputFieldGET[]) => {
      kd.legoDoll.outputFields = getResp;
      return { kitDoll: kd };
    },
  };
  return new KitDollPlan({ kitDollRequest: request });
}
// 8888888          d8b 888
//   888            Y8P 888
//   888                888
//   888   88888b.  888 888888
//   888   888 "88b 888 888
//   888   888  888 888 888
//   888   888  888 888 Y88b.
// 8888888 888  888 888  "Y888
function _planToinitKitDoll6(kitId: number) {
  const request = {
    method: HttpMethod.GET,
    path: `deep-kits-6/${kitId}`,
    options: { orgPath: true },
    callback: (getResp: EDeepKit6GET) => {
      return { kitDoll: _initKitDoll6(getResp) };
    },
  };
  return new KitDollPlan({ kitDollRequest: request });
}

function _planToUpdateKitName(kd: CmdProcessed, newName: string): KitDollPlan {
  const c = ocopy(kd);
  c.name = newName;

  const parallelRequests: ApiRequest[] = [
    {
      method: HttpMethod.PATCH,
      path: `kits/${c.kitId}`,
      body: enforceType<EKitPATCHReq>({ name: newName }),
      options: { orgPath: true },
    },
  ];

  // For CMD kits, also update the anchor lego name
  if (_isCmd(c)) {
    (c as CmdProcessed).legoDoll.legoName = newName;
    c.name = newName;
    parallelRequests.push({
      method: HttpMethod.PATCH,
      path: `command-templates/${(c as CmdProcessed).legoDoll.olId}`,
      body: enforceType<ECmdTemplatePATCHReq>({ overrideName: newName }),
      options: { orgPath: true },
    });
  }

  return new KitDollPlan({
    kitDoll: c,
    parallelRequests,
  });
}

export default {
  isCmd: _isCmd,
  bindUrlParams: _bindUrlParams,
  addressAmbiguousParams: _addressAmbiguousParams,
  toQueryString: _toQueryString,
  toExcelFormula: _toExcelFormula,
  setDefaultValues: _setDefaultValues,
  setEnvVariableValues: _setEnvVariableValues,
  initKitDoll6: _initKitDoll6,
  planToUpdateDbInfo: _planToUpdateDbInfo,
  planToUpdateLegoOld: _planToUpdateLegoOld,
  planToDeleteLegoInput: _planToDeleteLegoInput,
  planToUpdateLego: _planToUpdateLego,
  planToAddLegoInput: _planToAddLegoInput,
  planToBulkEditLegoInstanceInputs: _planToBulkEditLegoInstanceInputs,
  planToUpdateSchemaElement: _planToUpdateSchemaElement,
  planToReorderSchema: _planToReorderSchema,
  planToUpdateSchema: _planToUpdateSchema,
  planToUpdateLegoInstanceInput: _planToUpdateLegoInstanceInput,
  planToUpdateCredsApi: _planToUpdateCredsApi,
  planToUpdateDropdown: _planToUpdateDropdown,
  planToCreateDropdown: _planToCreateDropdown,
  planToUnlinkDropdown: _planToUnlinkDropdown,
  planToLinkDropdown: _planToLinkDropdown,
  planToSync: _planToSync,
  planToUpdateDirectory: _planToUpdateDirectory,
  initRecentKitDolls: _initRecentKitDolls,
  initPartialSkinnyKit: _initPartialSkinnyKit,
  initSkinnyKits: _initSkinnyKits,
  initSkinnyKitsOC: _initSkinnyKitsOC,
  initSkinnyKitOC: _initSkinnyKitOC,
  initSkinnyKitsIC: _initSkinnyKitsIC,
  initSkinnyKitIC: _initSkinnyKitIC,
  planToUpdateVisibility: _planToUpdateVisibility,
  planToCreateDecoration: _planToCreateDecoration,
  planToDeleteDecoration: _planToDeleteDecoration,
  planToUpdateDecoration: _planToUpdateDecoration,
  planToUpdateOutputColumns: _planToUpdateOutputColumns,
  planToCreateObjectDecoration: _planToCreateObjectDecoration,
  planToDeleteObjectDecoration: _planToDeleteObjectDecoration,
  planToUpdateObjectDecoration: _planToUpdateObjectDecoration,
  planToCreateErrorDecoration: _planToCreateErrorDecoration,
  planToDeleteErrorDecoration: _planToDeleteErrorDecoration,
  planToSwapErrorDecoration: _planToSwapErrorDecoration,
  planToUpdateOutputFields: _planToUpdateOutputFields,
  planToinitKitDoll6: _planToinitKitDoll6,
  planToUpdateKitName: _planToUpdateKitName,
};

// https://patorjk.com/software/taag/#p=display&f=Colossal&t=Math
